import React, { useState, useEffect, useRef } from 'react';
import { View, Text, Heading, Button, SelectField } from '@aws-amplify/ui-react';
import Loadingminier from './loadingminier';
import { Hub } from 'aws-amplify';
import { useSearchParams } from "react-router-dom";
import { getPortalSession } from '../auth/portalSession';
import { pathWritesFleetQuery, recalledFleets, rememberFleets } from '../withFleets';

async function fetchUserFleetsFromApi({ refresh = false } = {}) {
  return getPortalSession({ refresh });
}

export const Fleetselector = ({ selectedFleets, updateParentSelectedFleet, sidebarCollapsed, openSidebarCollapsed }) => {
  const [displayFleetSelectWindow, updateDisplayFleetSelectWindow] = useState(false);
  const [optionsArray, updateOptionsArray] = useState([]);
  const [isLoading, updateIsLoading] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const inFlightRef = useRef(false);

  async function getUserFleets(refresh = false) {
    if (inFlightRef.current) return;
    inFlightRef.current = true;
    updateIsLoading(true);
    try {
      const res = await fetchUserFleetsFromApi({ refresh });
      const fleets = res.fleet_codes ?? [];
      updateOptionsArray(fleets);

      // Default the sidebar only when nothing is selected yet. Fleet-agnostic
      // routes (admin user management, and the like) keep that default in
      // state and session, and do not grow a ?fleets= query.
      const liveParams = new URLSearchParams(window.location.search);
      if (fleets?.length > 0 && selectedFleets?.length === 0 && !liveParams.get("fleets")) {
        const remembered = recalledFleets();
        const next = remembered
          ? remembered.split(",").filter(Boolean)
          : [fleets[0]];
        if (next.length > 0) {
          updateParentSelectedFleet(next);
          if (!remembered) rememberFleets(next);
          if (pathWritesFleetQuery(window.location.pathname)) {
            liveParams.set("fleets", next.join(","));
            setSearchParams(liveParams);
          }
        }
      }


    } catch (e) {
      console.error("Fleet selector error:", e);
    } finally {
      inFlightRef.current = false;
      updateIsLoading(false);
    }
  }

  useEffect(() => {
    getUserFleets();
    // Refetch on sign-in only. tokenRefresh was looping the shell read.
    const removeHub = Hub.listen('auth', ({ payload: { event } }) => {
      if (event === 'signIn') {
        getUserFleets(true);
      }
    });
    return () => removeHub();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const selectedFleet = selectedFleets?.[0] ?? "";

  const selectFleet = (newFleet) => {
    if (selectedFleet !== newFleet) {
      updateParentSelectedFleet([newFleet]);
      rememberFleets([newFleet]);
      if (!pathWritesFleetQuery(window.location.pathname)) return;
      const newParams = new URLSearchParams(searchParams.toString());
      newParams.set("fleets", newFleet);
      setSearchParams(newParams);
    }
  };

  return (
    <View textAlign="center">
      {isLoading ? <Loadingminier /> :
        !selectedFleet ? <Text color="#fff">No Available Fleets</Text> :
        sidebarCollapsed ? 
            <Text
            style={{
              fontSize: "6pt",
              color: "#ffffff",
              opacity: 0.85,
              marginTop: 6,
              cursor: "pointer"
            }}
            onClick={() => {
              openSidebarCollapsed();
              updateDisplayFleetSelectWindow(true);
            }}
          >
            {selectedFleet}
          </Text>
        : displayFleetSelectWindow ? 
        <View>
          <Heading level={4} color="#ffffff">Select Fleet</Heading>
          <SelectField
            size="small"
            value={selectedFleet}
            onChange={(e) => selectFleet(e.target.value)}
            labelHidden
            style={{ color: "#ffffff" }}
          >
            {optionsArray.map(fleet => <option key={fleet} value={fleet}>{fleet}</option>)}
          </SelectField>
          <Button variation="link" onClick={() => updateDisplayFleetSelectWindow(false)}>CLOSE</Button>
        </View>
        :
        <Button variation="link" onClick={() => updateDisplayFleetSelectWindow(true)}>{selectedFleet}</Button>
      }
    </View>
  );
};


export default Fleetselector;
